module.exports = __webpack_public_path__ + "static/nike-img-2-da1f330cbb8983363f6fcf11921eb227.jpg";